import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=403aadfa&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=403aadfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403aadfa",
  null
  
)

export default component.exports